import axios from 'axios';
import { baseUrl_SPB } from '../BaseUrl';

const connectBaseUrl = `${baseUrl_SPB}/api/v1/aws/connect`;

const authHeaders = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const requestConfig = (token, companyId) => {
  const config = authHeaders(token);
  if (companyId) {
    config.params = { companyId };
  }
  return config;
};

export const resolveCompanyId = (additionalUserInfo) => (
  additionalUserInfo?.companyId
  || additionalUserInfo?.company?.companyId
  || additionalUserInfo?.company?.id
  || null
);

export const listAvailableNumbers = async (token, companyId) => {
  const response = await axios.get(`${connectBaseUrl}/numbers`, requestConfig(token, companyId));
  return response.data || [];
};

export const allocateNumber = async (token, companyId, payload) => {
  const response = await axios.post(`${connectBaseUrl}/allocate`, payload, requestConfig(token, companyId));
  return response.data;
};

export const requestNumber = async (token, companyId, payload) => {
  const response = await axios.post(`${connectBaseUrl}/allocate`, payload, requestConfig(token, companyId));
  return response.data;
};

export const portNumber = async (token, companyId, payload) => {
  await axios.post(`${connectBaseUrl}/port`, payload, requestConfig(token, companyId));
};

export const changeNumber = async (token, companyId, payload) => {
  const response = await axios.put(`${connectBaseUrl}/change`, payload, requestConfig(token, companyId));
  return response.data;
};

export const getApiErrorMessage = (error) => {
  if (error?.response?.data?.message) return error.response.data.message;
  if (typeof error?.response?.data === 'string') return error.response.data;
  if (error?.message) return error.message;
  return 'Request failed. Please verify payload fields with backend DTOs.';
};
